import { useContext } from "react";

import { permissionContext } from "../context";

export const usePermissionContext = () => useContext(permissionContext);
